import { isNull } from './utils';

export const freeze = (object: any) => {
    if (isNull(object)) { return object }

    Object.freeze(object);

    Object.getOwnPropertyNames(object)
        .forEach((prop) => {
            const value = object[prop];

            if (object.hasOwnProperty(prop)
                && (typeof value === 'object')
                && value
                && !Object.isFrozen(value)) {

                freeze(value);
            }
        });

    return object;
};
